import React, {useState} from 'react'

import SeasonSerie from "@/components/season/SeasonSerie"
import CardContent from "@/components/card/CardContent"

import './styles/season-series.scss'

function SeasonSeries() {
    const [series, setSeries] = useState<unknown[]>([{}]);

    const onRemoveSerie = (index:number) => {
        setSeries((prev) => prev.filter((_, i) => i !== index))
    }

    const onAddSerie = () => {
        setSeries((prev) => [...prev, {}]);
    }

    return (
        <section className="season-series">
            <div className={"season-series__list"}>
                {series.map((season, index) => {
                    return (
                        <CardContent key={index} title={`Серия ${index + 1}`}>
                            <SeasonSerie isShowControl={true} remove={onRemoveSerie} index={index} />
                        </CardContent>
                    )
                })}
            </div>

            <div className={"season-series__control"}>
                <button className={"app-btn"} onClick={onAddSerie}>
                    Добавить серию
                </button>
            </div>
        </section>
    )
}

export default SeasonSeries